module.exports = __webpack_public_path__ + "img/logo.20cdc5bb.png";